import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { cartStyles } from '../styles/cartBtn';
import { useNavigation, useRoute } from '@react-navigation/native';
import { useDispatch, useSelector } from 'react-redux';

const CartBtn = () => {
  const navigation = useNavigation();

  const dispatch = useDispatch();
  const selectedItems = useSelector((state) => state.selectedItems);

  const handleAddToCart = () => {
    navigation.navigate('Cart');
  };

  const totalCost = selectedItems.reduce(
    (total, item) => total + item.price,
    0,
  );

  return (
    <View style={cartStyles.buttonWrapper}>
      <View style={cartStyles.btnContainer}>
        <TouchableOpacity style={cartStyles.button} onPress={handleAddToCart}>
          <Text style={cartStyles.buttonText}>Add to cart</Text>
          <Text style={cartStyles.totalText}>Total Price: {totalCost}</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default CartBtn;
